module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsSAAALEgHS3X78AAAAu0lEQVQ4jc3Tyw0CIRSF4V9jAVZAXFCAJWgHtuCSnVOCFehutnZgCWoHUwCJhgqmhMlNwPgYRkAXng2PhC83F+BXGeU61qgZsAJaXbtD2M+CrFFz4ARM/dZe166SyfgLRLIJkyQogkiaZGgAaYF1WAz26AOy1LW7VxSFcpAolIv0QiXIG1SK0HNrxxLkCbJGCbL1B7OQ14oWwA6oPJCMEHrkP+L1oQrBmlREMvGj9OUMXPyzF+SWivxhgA6U4k/KWr0uiwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/ic_btn_edit_press.png
// module id = 725
// module chunks = 0